import { Link } from "react-router-dom";
import AdminLayout from "../AdminLayout";
import { useAdminSession } from "../AdminSessionContext";

const cards = [
  { to: "/admin/estado", icon: "ri-toggle-line", title: "Estado del sitio", desc: "Activa o desactiva la página pública (modo en construcción)." },
  { to: "/admin/settings", icon: "ri-store-2-line", title: "Datos del sitio", desc: "Marca, contacto, horarios, WhatsApp, SEO y mapa." },
  { to: "/admin/banner", icon: "ri-slideshow-3-line", title: "Banner Principal", desc: "Imágenes con texto que rotan arriba en la página de inicio." },
  { to: "/admin/recinto", icon: "ri-building-line", title: "Sección «El recinto»", desc: "Título, texto y foto de la sección oscura del inicio." },
  { to: "/admin/textos", icon: "ri-text", title: "Textos del sitio", desc: "Encabezados, botones, menú, pie de página y mensajes de todas las páginas." },
  { to: "/admin/google-drive", icon: "ri-drive-line", title: "Google Drive", desc: "Credenciales para subir imágenes a Google Drive." },
  { to: "/admin/bodegas", icon: "ri-archive-line", title: "Bodegas", desc: "Catálogo de unidades disponibles." },
  { to: "/admin/planes", icon: "ri-layout-grid-line", title: "Planes", desc: "Los formatos de arriendo y sus rangos de tamaño." },
  { to: "/admin/faqs", icon: "ri-question-line", title: "Preguntas frecuentes", desc: "Preguntas y respuestas del sitio." },
  { to: "/admin/testimonios", icon: "ri-chat-quote-line", title: "Testimonios", desc: "Opiniones de clientes." },
  { to: "/admin/bloques", icon: "ri-stack-line", title: "Bloques de contenido", desc: "Listas de Home, Nosotros, Seguridad y Ubicación." },
  { to: "/admin/paginas", icon: "ri-file-text-line", title: "Páginas", desc: "Encabezados y textos de cada página." },
  { to: "/admin/contactos", icon: "ri-mail-line", title: "Contactos", desc: "Mensajes recibidos por el formulario." },
  { to: "/admin/formulario", icon: "ri-survey-line", title: "Formulario de contacto", desc: "Textos, campos y opciones del formulario de contacto." },
  { to: "/admin/correo", icon: "ri-send-plane-line", title: "Correo del formulario", desc: "Servidor de correo (SMTP), aviso de solicitudes y respuesta automática." },
  { to: "/admin/usuarios", icon: "ri-team-line", title: "Usuarios", desc: "Administra las cuentas con acceso al panel." },
  { to: "/admin/medios", icon: "ri-image-line", title: "Medios", desc: "Sube y gestiona las imágenes del sitio." },
];

export default function AdminDashboard() {
  const { admin } = useAdminSession();

  return (
    <AdminLayout>
      <h1 className="font-heading font-bold text-2xl text-foreground-950">Hola, {admin?.email}</h1>
      <p className="mt-1 text-sm text-foreground-500">¿Qué quieres administrar hoy?</p>

      <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-4">
        {cards.map((c) => (
          <Link
            key={c.to}
            to={c.to}
            className="rounded-lg border border-background-200 bg-background-50 p-6 hover:border-primary-300 hover:-translate-y-0.5 transition"
          >
            <span className="w-11 h-11 rounded-lg bg-primary-100 text-primary-600 flex items-center justify-center">
              <i className={`${c.icon} text-xl`} />
            </span>
            <h2 className="mt-4 font-heading font-semibold text-foreground-900">{c.title}</h2>
            <p className="mt-1 text-sm text-foreground-500">{c.desc}</p>
          </Link>
        ))}
      </div>
    </AdminLayout>
  );
}
